/**
 * Protected Route Component
 * Wraps routes that require authentication (SIMPLIFIED VERSION)
 */

import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/features/authentication/hooks/useAuth';
import { Spinner } from '@/shared/components/Loading/Spinner';

type ProtectedRouteProps = {
  children: React.ReactNode;
};

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <Spinner className="mx-auto mb-4" />
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated - ONLY basic check
  if (!isAuthenticated || !user) {
    console.log('ProtectedRoute: user not authenticated, redirecting to login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // All checks passed - render protected content
  // Other validations (onboarding, account status, roles) should be
  // handled by individual components/pages, not at the route level
  return <>{children}</>;
}

